import React, { createContext, useContext, useState, useEffect } from 'react';
import { getAppSettings, AppSettings } from '@/api/settings';

interface SettingsContextType {
  settings: AppSettings;
  refreshSettings: () => Promise<void>;
}

const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

export function SettingsProvider({ children }: { children: React.ReactNode }) {
  const [settings, setSettings] = useState<AppSettings>({
    minOrderAmount: 0,
    paymentMethodsText: '',
    paymentMethods: [],
    googleAnalyticsId: '',
    orderConfirmationText: ''
  });

  const refreshSettings = async () => {
    const newSettings = await getAppSettings();
    setSettings(newSettings);
  };

  useEffect(() => {
    refreshSettings();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const context = useContext(SettingsContext);
  if (context === undefined) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
} 